export class YardiClientMapping {
    public id: number;
    public voyagerUrl: string;
    public riqClientId: number;
    public userName: string;
    public password: string;
    public databaseName: string;
    public serverName: string;
    public voyagerVersion: string;
    public shortReport: boolean;
}

export class YardiPropertyConfiguration {
    public code : string;
    public marketingName : string;
    public addressLine1 : string;
    public addressLine2 : string;
    public addressLine3 : string;
    public city : string;
    public state : string;
    public postalCode : string;
}

export class YardiPropertyMapping {
    public id: number;
    public locationId: string;
    public clientId: string;
    public riqClientLocationId: number;
}

export class YardiClientMeta {
	public clientConnectedDate: Date;
	public dateLastTransferred: Date;

}